<template>
  <div>
    <Head>
      <Title>{{ $t('pages.game.meta.title', useGameParams(game)) }}</Title>
      <Meta name="description" :content="$t('pages.game.meta.description.football', useGameParams(game))" />
      <!-- <Link rel="canonical" :href="useAbsolutePath()" /> -->
    </Head>
    <div class="space-y-4">
      <GameHero :game="game" />
      <GameGoals :game="game" v-if="game.status == 'finished'" />
      <GameTable :game="game" v-if="game.table?.length" />
      <GameStats :game="game" v-if="game.status == 'finished'" />
      <GameEvents :game="game" v-if="game.status == 'finished'" />
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'team',
  middleware: ['game-data'],
})

const route = useRoute()
const game = useState(`game:${route.params?.game}`)

// Show 404 if no game is found
if (!game.value?.id || !game.value.slug) {
  throw createError({
    statusCode: 404,
    message: 'not found',
    fatal: true
  })
}
</script>
